
<template>
  <div class="appDashboard dashboard2">
    <div :class="{container:appConfig.container}">
      <app-header :title="title"></app-header>
    </div>
    <v-layout class="flex md12 ml-1" :class="{container:appConfig.container}" row wrap>
      <app-card class="md12 sm12 xs12 d-flex" :obj="{title}">
        <div slot="body">
          <v-layout style="position: absolute; left: 50px;">
            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickAutoUpdate"
            >
              {{ $t('CurrentStatus.AutoUpdate')}}
              <span v-if="isAutoUpdate">({{countDownTimer}})</span>
            </v-btn>
            <v-btn
              depressed
              color="primary"
              :disabled="!isAutoUpdate"
              v-on:click="onClickStopUpdate"
            >{{ $t('CurrentStatus.StopUpdate')}}</v-btn>

            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickUpdate"
            >{{ $t('CurrentStatus.ManualUpdate')}}</v-btn>
          </v-layout>
          <v-layout>
            <span v-if="onOffStatus == 'ON-LINE'" class="onStatus">{{onOffStatus}}</span>
            <span v-if="onOffStatus == 'OFF-LINE'" class="offStatus">{{onOffStatus}}</span>
          </v-layout>
          <v-layout style="position: absolute; right: 50px;">
            <v-btn depressed class="v-btn v-btn--depressed theme--light info" v-on:click="onClickTop" >{{ $t('CurrentStatus.GoToTop')}}</v-btn>
            <v-btn depressed class="v-btn v-btn--depressed theme--light info" v-on:click="onClickUp">{{ $t('CurrentStatus.GoToUp')}}</v-btn>
          </v-layout>
          <object
            id="svg-fig"
            :data="svgUrl"
            type="image/svg+xml"
            width="100%"
            height="100%"
            style="margin-top: 50px;"
          ></object>
        </div>
      </app-card>
    </v-layout>
  </div>
</template>

<script>
import mediator from "../../components/common/mediator.vue";
import moment from "moment";
import locale from "../../utility/Locale";

export default {
  name: "CellStatus",
  mixins: [mediator],

  mounted() {
    $(".appCard__header").remove();
    this.title = this.$root.currentPageName;

    this.setSvgUrl();
    setTimeout(() => {
      this.viewSVG();
      // デフォルトで自動更新
      this.onClickAutoUpdate();
    }, this.$root.svgWaitingTime);
  },
  beforeDestroy() {
    clearInterval(this.$root.currentTimer);
  },
  data() {
    const $t = this.$t.bind(this);

    return {
      title: $t("CellStatus.Item"),
      $fig: null,
      isAutoUpdate: false,
      countDownTimer: 10,
      svgUrl: "",
      onOffStatus: ''
    };
  },
  methods: {
    onClickUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;
      this.viewSVG();
    },
    onClickAutoUpdate() {
      this.isAutoUpdate = true;

      this.$root.currentTimer = setInterval(() => {
        if (!this.isAutoUpdate) {
          clearInterval(this.$root.currentTimer);
        }

        if (this.countDownTimer === 0) {
          this.viewSVG();
          this.countDownTimer = 10;
        } else {
          this.countDownTimer--;
        }
      }, 1000);
    },
    onClickStopUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;
    },
    onClickTop() {
      this.$router.push({ name: "top_page" });
    },
    onClickUp() {
      this.$router.push({ name: "pack_status" });
    },
    setSvgUrl() {
      if (process.env.NODE_ENV === "development") {
        if (locale.getCurrentLanguage() === "ja") {
          this.svgUrl = "/static/svg/cell_jp.svg";
        } else {
          this.svgUrl = "/static/svg/cell_cn.svg";
        }
      } else {
        if (locale.getCurrentLanguage() === "ja") {
          this.svgUrl = "static/svg/cell_jp.svg";
        } else {
          this.svgUrl = "static/svg/cell_cn.svg";
        }
      }
    },
    viewSVG() {
      let vm = this;
      vm.$fig = $(document.getElementById("svg-fig").contentDocument);

      vm.axios
        .get(`${vm.$root.url}/Customer/PackStatus4Cell`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            systemSn: vm.$root.currentSerial.system,
            packSn: vm.$root.currentSerial.pack
          }
        })
        .then(response => {
          let data = response.data;
          this.onOffStatus = data[0].onOffStatus;
          this.setPackBase(data[0]);

          vm.loading = false;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
          vm.showResult = true;
        });

      vm.axios
        .get(`${vm.$root.url}/Customer/CellStatus`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            packSn: vm.$root.currentSerial.pack
          }
        })
        .then(response => {
          let data = response.data;
          this.setCellVisible(data[0]);
          this.setCellBase(data[0]);

          vm.loading = false;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
          vm.showResult = true;
        });
    },
    setPackBase(data) {
      let $base_txt_title = this.$fig.find("#base-txt-title");
      $base_txt_title.text(data.systemNm);

      let $base_data_packno = this.$fig.find("#base-data-packno");
      $base_data_packno.text(data.packNo);

      let $base_data_packserial = this.$fig.find("#base-data-packserial");
      $base_data_packserial.text(data.packSn);

      let $base_data_voltage = this.$fig.find("#base-data-voltage");
      $base_data_voltage.text(data.totalVolt + " V");

      let $base_data_current = this.$fig.find("#base-data-current");
      $base_data_current.text(data.totaCurrent + " A");

      let $base_data_time = this.$fig.find("#base-data-time");
      $base_data_time.text(data.serverTime);

      // let $base_data_sw = this.$fig.find("#base-data-sw");
      // $base_data_sw.text(data.version);

      // let $base_data_soh = this.$fig.find("#base-data-soh");
      // $base_data_soh.text(data.soh + " %");

      let $base_data_soc = this.$fig.find("#base-data-soc");
      $base_data_soc.text(data.soc + " %");

      let $base_data_cell_high = this.$fig.find("#base-data-cell-high");
      $base_data_cell_high.text(data.maxCellVolt + " V");

      let $base_data_cell_low = this.$fig.find("#base-data-cell-low");
      $base_data_cell_low.text(data.minCellVolt + " V");

      let $base_data_cell_high_cell = this.$fig.find(
        "#base-data-cell-high-cell"
      );
      $base_data_cell_high_cell.text(`CELL ${data.maxVoltPack}`);

      let $base_data_cell_low_cell = this.$fig.find("#base-data-cell-low-cell");
      $base_data_cell_low_cell.text(`CELL ${data.minVoltPack}`);

      let $base_data_temp_high = this.$fig.find("#base-data-temp-high");
      $base_data_temp_high.text(data.maxTemperature + " ℃");

      let $base_data_temp_low = this.$fig.find("#base-data-temp-low");
      $base_data_temp_low.text(data.minTemperature + " ℃");

      let $base_data_temp_high_cell = this.$fig.find(
        "#base-data-temp-high-cell"
      );
      $base_data_temp_high_cell.text(`TEMP ${data.maxTemperaturePack}`);

      let $base_data_temp_low_cell = this.$fig.find("#base-data-temp-low-cell");
      $base_data_temp_low_cell.text(`TEMP ${data.minTemperaturePack}`);

      let $errorcode = this.$fig.find("#base-data-errorcode");
      $errorcode.text(`0x${data.packErrorCode}`);

      const alarm = Array.from(data.alarm).reverse();
      alarm.map((error, index) => {
        let $error_f_val = null;
        let $error_txt = null;
        switch (index) {
          case 0: // OVP
            $error_f_val = this.$fig.find("#base-bg-ovp-f");
            $error_txt = this.$fig.find("#base-txt-ovp");
            break;
          case 1: // UVP
            $error_f_val = this.$fig.find("#base-bg-uvp-f");
            $error_txt = this.$fig.find("#base-txt-uvp");
            break;
          case 2: // OCP
            $error_f_val = this.$fig.find("#base-bg-ocp-f");
            $error_txt = this.$fig.find("#base-txt-ocp");
            break;
          case 3: // UCP
            $error_f_val = this.$fig.find("#base-bg-ucp-f");
            $error_txt = this.$fig.find("#base-txt-ucp");
            break;
          case 4: // OTP
            $error_f_val = this.$fig.find("#base-bg-otp-f");
            $error_txt = this.$fig.find("#base-txt-otp");
            break;
          case 5: // UTP
            $error_f_val = this.$fig.find("#base-bg-utp-f");
            $error_txt = this.$fig.find("#base-txt-utp");
            break;
        }

        if (error === "1") {
          if ($error_f_val) {
            $error_f_val.css("display", "inherit");
            $error_f_val.css("fill", "#ff3121");
            $error_txt.css("fill", "#ffffff");
          }
        } else {
          if ($error_f_val) {
            $error_f_val.css("display", "none");
            $error_txt.css("fill", "#727272");
          }
        }
      });
    },
    setCellVisible(data) {
      let cellCount = data.cellcntVl;
      for (var i = 0; i < cellCount; i++) {
        let $onoff_val = this.$fig.find(`#cell-${data.cellNos[i]}`);
        if (i <= cellCount) {
          $onoff_val.css('display', 'inline');
        } else {
          $onoff_val.css('display', 'none');
        }
      }
    },

    setCellBase(data) {
      let cellCount = data.cellcntVl;

      let $base_txt_acb_01 = this.$fig.find('#base-txt-acb-01');
      let $base_txt_acb_02 = this.$fig.find('#base-txt-acb-02');
      let $base_txt_tantai_01 = this.$fig.find('#base-txt-tantai-01');
      let $base_txt_tantai_02 = this.$fig.find('#base-txt-tantai-02');

      if (cellCount == 0) {
        $base_txt_acb_01.css('display', 'none');
        $base_txt_acb_02.css('display', 'none');
        $base_txt_tantai_01.css('display', 'none');
        $base_txt_tantai_02.css('display', 'none');
      } else if (cellCount <= 18 && cellCount >= 1) {
        $base_txt_acb_01.css('display', 'inherit');
        $base_txt_acb_02.css('display', 'none');
        $base_txt_tantai_01.css('display', 'inherit');
        $base_txt_tantai_02.css('display', 'none');
      } else if (cellCount >= 19) {
        $base_txt_acb_01.css('display', 'inherit');
        $base_txt_acb_02.css('display', 'inherit');
        $base_txt_tantai_01.css('display', 'inherit');
        $base_txt_tantai_02.css('display', 'inherit');
      }

      for (var i = 0; i < cellCount; i++) {
        let $cellname_val = this.$fig.find(`#cell-txt-name-${data.cellNos[i]}`);
        $cellname_val.text(data.cellNos[i]);

        let $cellvolt_val = this.$fig.find(`#cell-data-volt-${data.cellNos[i]}`);
        $cellvolt_val.text(`${data.cellVolts[i].measureVl}V`);
      }

      this.setTemperature(data);
      this.setSwitch(data);
      this.setCellImage(data)
    },

    setTemperature(data) {
      // 温度(Pack共通)
      let tempCount = data.tempcntVl;

      for (var i = 0; i < tempCount; i++) {
        let $base_temp_label = this.$fig.find(`#base-temp-label-0${i + 1}`);
        let $base_temp = this.$fig.find(`#base-temp-0${i + 1}`);

        if (i < tempCount) {
          $base_temp_label.css('display', 'inherit');
          $base_temp.css('display', 'inherit');

          let $base_temp_value = this.$fig.find(`#base-temp-0${i + 1}`);
          $base_temp_value.text(`${data.cellTemps[i].measureVl}℃`);
        } else {
          $base_temp_label.css('display', 'none');
          $base_temp.css('display', 'none');
        }
      }
    },

    setCellImage(data) {
      let cell_volt_min = 0;
      let cell_volt_max = 4.5;
      let positiony = 350;

      let cellCount = data.cellcntVl;

      let volt_maxmin = [];
      for (var i = 0; i < cellCount; i++) {
        volt_maxmin.push(data.cellVolts[i].measureVl);
      }
      let volt_max_val = Math.max.apply(null, volt_maxmin.slice(0, cellCount));
      let volt_min_val = Math.min.apply(null, volt_maxmin.slice(0, cellCount));

      for (var i = 0; i < cellCount; i++) {
        if (i > 17) {
          positiony = 760;
        }

        let percent = data.cellVolts[i].measureVl / (cell_volt_max - cell_volt_min);
        if(percent > 1){
          percent = 1;
        }
        let barheight = 135 * percent;

        let $cell_scale_green = this.$fig.find(`#cell-scale-green-${data.cellNos[i]}`);
        let $cell_scale_min = this.$fig.find(`#cell-scale-min-${data.cellNos[i]}`);
        let $cell_scale_max = this.$fig.find(`#cell-scale-max-${data.cellNos[i]}`);

        if(volt_max_val != volt_min_val) {
          if(data.cellVolts[i].measureVl == volt_max_val){//2020-3-28 19:30修正
            $cell_scale_green.css('display', 'none');
            $cell_scale_min.css('display', 'none');
            $cell_scale_max.css('display', 'inherit');
            $cell_scale_max.css('height', barheight);
            $cell_scale_max.attr('y',positiony + 135 - barheight);
          } else if (data.cellVolts[i].measureVl == volt_min_val){
            $cell_scale_green.css('display', 'none');
            $cell_scale_min.css('display', 'inherit');
            $cell_scale_min.css('height', barheight);
            $cell_scale_min.attr('y',positiony + 135 - barheight);
            $cell_scale_max.css('display', 'none');
          } else {
            $cell_scale_green.css('display', 'inherit');
            $cell_scale_green.css('height', barheight);
            $cell_scale_green.attr('y',positiony + 135 - barheight);
            $cell_scale_min.css('display', 'none');
            $cell_scale_max.css('display', 'none');
          }
        } else {
          $cell_scale_green.css('display', 'inherit');
          $cell_scale_green.css('height', barheight);
          $cell_scale_green.attr('y',positiony + 135 - barheight);
          $cell_scale_min.css('display', 'none');
          $cell_scale_max.css('display', 'none');
        }
      }
    },

    setSwitch(data) {

      for(let i=0; i < data.cellNos.length; i++) {
        let $cellarrow_right = this.$fig.find(`#cell-arrow-right-${data.cellNos[i]}`);
        let $cellarrow_left = this.$fig.find(`#cell-arrow-left-${data.cellNos[i]}`);
        $cellarrow_right.css('display', 'none');
        $cellarrow_left.css('display', 'none');
      }

      // スイッチ1 (No1～No32 ACB表示:MC ACB方向:MD)
      // 全ての要素に同じ値が入っているので１つだけ取り出す
      const onOffValue1 = Array.from(data.acbOnOff1).reverse();
      const directionValue1 = Array.from(data.acbDirection1).reverse();
      onOffValue1.map((onOff, index) => {
        if (index < data.cellNos.length && index < 32) {
          let $cellarrow_right = this.$fig.find(`#cell-arrow-right-${data.cellNos[index]}`);
          let $cellarrow_left = this.$fig.find(`#cell-arrow-left-${data.cellNos[index + 1]}`);

          if (onOff == 1) { // 表示
            if (directionValue1[index] == 0) { // 方向
              $cellarrow_right.css('display', 'inherit');
              $cellarrow_left.css('display', 'none');
            } else {
              $cellarrow_right.css('display', 'none');
              $cellarrow_left.css('display', 'inherit');
            }
          } else {
            $cellarrow_right.css('display', 'none');
            $cellarrow_left.css('display', 'none');
          }
        }

      });

      // スイッチ2 (No33～No36 ACB表示:ME ACB方向:MF)
      if (data.acbOnOff2) {
        const onOffValue2 = Array.from(data.acbOnOff2).reverse();
        const directionValue2 = Array.from(data.acbDirection2).reverse();
        onOffValue2.map((onOff, index) => {
          let index2 = index + 32
          if (index2 < data.cellNos.length && index < 4)  {
            let $cellarrow_right = this.$fig.find(`#cell-arrow-right-${data.cellNos[index2]}`);
            let $cellarrow_left = this.$fig.find(`#cell-arrow-left-${data.cellNos[index2 + 1]}`);

            if (onOff == 1) { // 表示
              if (directionValue2[index] == 0) { // 方向
                $cellarrow_right.css('display', 'inherit');
                $cellarrow_left.css('display', 'none');
              } else {
                $cellarrow_right.css('display', 'none');
                $cellarrow_left.css('display', 'inherit');
              }
            } else {
              $cellarrow_right.css('display', 'none');
              $cellarrow_left.css('display', 'none');
            }
          }
        });
      }

    }
  }
};
</script>

<style>
.dashboard2 {
  z-index: 9;
}

.dashboard2 .offset-sm3 {
  margin: 0 !important;
  flex-basis: 100% !important;
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/router/Customer/CellStatus.vue